import { PureComponent } from "react";
import { TriggerButton } from "widgets";

import { pluralizeWord } from "@/app-utils/string.ts";
import type { Sample } from "@/graphql.ts";
import { getTableQuerySpecWithSelection, type ITableData } from "@/redux/modules/table-data.ts";
import { SAMPLES_COUNT_EDITING_LIMIT } from "@/settings/settings.js";

import SampleEditingWizard from "../playbooks/sample/SampleEditingWizard.js";

export interface IEditSamplesButtonProps {
  activeTable: ITableData;
}

interface IEditSamplesButtonState {
  showEditWizard: boolean;
}

/**
 * Button that allows to push a selection of samples (or full group) to the edit Playbook
 *
 */
class EditSamplesButton extends PureComponent<IEditSamplesButtonProps, IEditSamplesButtonState> {
  constructor(props: IEditSamplesButtonProps) {
    super(props);
    this.state = { showEditWizard: false };
  }

  disabledTooltipText = () => {
    const table: ITableData = this.props.activeTable;
    const count: number = table.selectionModel.selectedIds.length || table.filteredRowCount || 0;

    if (count > SAMPLES_COUNT_EDITING_LIMIT) {
      return `You can edit at most ${SAMPLES_COUNT_EDITING_LIMIT} samples.`;
    } else if (count === 0) {
      return "At least one row must be selected to perform an editing.";
    } else if (
      table.pageRows.find(
        (row) =>
          (row as Sample).locked &&
          (table.selectionModel.selectedIds.length === 0 ||
            table.selectionModel.selectedIds.find((id) => id === row.id)),
      )
    ) {
      return "Editing is not possible because your selection contains locked samples.";
    }
    return null;
  };

  render() {
    const table: ITableData = this.props.activeTable;
    const disabledTooltip: string = this.disabledTooltipText();
    const count: number = table.selectionModel.selectedIds.length || table.filteredRowCount || 0;
    return (
      <>
        <TriggerButton
          key={"edit-samples-btn-header"}
          isDisabled={disabledTooltip}
          icon={"edit"}
          tooltip={`Add or modify sample data (${count} ${pluralizeWord("sample", count)})`}
          onPress={() => this.setState({ showEditWizard: true })}
          label={"Edit"}
          showLabel
        />

        {this.state.showEditWizard && (
          <SampleEditingWizard
            tableSpecWithSelection={getTableQuerySpecWithSelection(this.props.activeTable)}
            onClose={() => this.setState({ showEditWizard: false })}
          />
        )}
      </>
    );
  }
}

export default EditSamplesButton;
